import { render } from "./RateData.vue?vue&type=template&id=cb7af06a&scoped=true"
import script from "./RateData.vue?vue&type=script&lang=js"
export * from "./RateData.vue?vue&type=script&lang=js"

import "./RateData.vue?vue&type=style&index=0&id=cb7af06a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cb7af06a"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBadge from 'quasar/src/components/badge/QBadge.js';
import QChip from 'quasar/src/components/chip/QChip.js';
import QMenu from 'quasar/src/components/menu/QMenu.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QCircularProgress from 'quasar/src/components/circular-progress/QCircularProgress.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';import TouchHold from 'quasar/src/directives/TouchHold.js';
import qInstall from "../../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QBadge,QChip,QMenu,QList,QItem,QItemSection,QCircularProgress,QIcon});qInstall(script, 'directives', {TouchHold});
